import { ModalLoader } from '@fiverr-private/overlay';

export default ModalLoader;
